import { useCallback } from "@";

// Hook for handling file uploads
export const useUpload = (setValue) => {
  const handleUpload = useCallback(
    (file, to) => {
      setValue(to, file);
    },
    [setValue],
  );

  return { handleUpload };
};
